// sync with backend/utils/enums.py:ErrorCodesEnum
export enum ERROR_CODES {
  USER_EMAIL_EXISTS = 'USER_EMAIL_EXISTS',
  INVITE_EMAIL_EXISTS = 'INVITE_EMAIL_EXISTS',
  INVITE_TOO_FREQUENT = 'INVITE_TOO_FREQUENT',
  ORG_MAX_USERS = 'ORG_MAX_USERS',
  PLAN_NO_MULTI_ORG_CREATE = 'PLAN_NO_MULTI_ORG_CREATE',
  PLAN_NO_MULTI_ORG_INVITE = 'PLAN_NO_MULTI_ORG_INVITE',
  NO_ORG_AUTHORITY = 'NO_ORG_AUTHORITY',
  NO_ORG_INTEGRATION = 'NO_ORG_INTEGRATION',
}

export type ErrorCode = keyof typeof ERROR_CODES;

// temporary language (i18n eventually)
export const errorLanguage: { [key in ERROR_CODES]: string } = {
  USER_EMAIL_EXISTS: 'User already exists with that email',
  INVITE_EMAIL_EXISTS: 'Invite email already exists',
  INVITE_TOO_FREQUENT: 'Recently invited, please wait to resend invite',
  ORG_MAX_USERS:
    'This organization cannot have any more members, please contact our support team',
  PLAN_NO_MULTI_ORG_CREATE:
    'Your organization’s billing plan does not support the multi-organization feature',
  PLAN_NO_MULTI_ORG_INVITE:
    'An account already exists for that email, and your organization’s billing plan does not support multi-organization accounts',
  NO_ORG_AUTHORITY: '',
  NO_ORG_INTEGRATION: 'This integration is not active for your organization.',
};

export type ErrorWithCode = Error & {
  code: string;
};
